
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prosjekt/[slug]",
      function () {
        return require("private-next-pages/prosjekt/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prosjekt/[slug]"])
      });
    }
  